module.exports = __webpack_public_path__ + "static/Vedalken_male_Mizzium_Meddler-3ff707231e84cb8a67a6e3eba3f06b78.jpg";